export function checkAccountType(data, accountType){
    if(data){
        return data.accountType === accountType;
    }
}